import React from 'react';
import {
  diaChiNhanHangSearchColumns,
  phuongThucThanhToanSearchColumns,
  QUERY_KEYS,
  warehouseSearchColumns
} from '@/constants';
import { FormFieldV2, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { DiaChiNhanHang, KhoHang, PhuongThucThanhToan } from '@/types/schemas';
import { FormFieldActions, FormFieldState } from '../../hooks';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface DeliveryInfoTabProps {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export const DeliveryInfoTab = ({ formMode, formState: { state, actions } }: DeliveryInfoTabProps) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex flex-wrap gap-4'>
          <div className='flex items-center'>
            <Label className='w-32 min-w-32'>Điện thoại</Label>
            <div className='w-[195px]'>
              <FormFieldV2 name='dien_thoai' type='text' disabled={formMode === 'view'} />
            </div>
          </div>
          <div className='flex items-center'>
            <Label className='w-10 min-w-10'>Fax</Label>
            <FormFieldV2 name='fax' type='text' disabled={formMode === 'view'} />
          </div>
        </div>
      </div>

      <div className='flex items-center'>
        <Label className='w-32 shrink-0'>Nơi nhận</Label>
        <SearchField<DiaChiNhanHang>
          type='text'
          name='ma_dcnh'
          searchEndpoint={`/${QUERY_KEYS.DIA_CHI_GIAO_NHAN_HANG}/`}
          searchColumns={diaChiNhanHangSearchColumns}
          value={state.diaChi?.ma_dcnh || ''}
          relatedFieldValue={state.diaChi?.ten_dcnh}
          onRowSelection={actions.setDiaChi}
          columnDisplay='ma_dcnh'
          displayRelatedField='ten_dcnh'
          dialogTitle='Danh mục địa chỉ nhận hàng'
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-32 shrink-0'>Kho nhận</Label>
        <SearchField<KhoHang>
          type='text'
          name='ma_kho'
          searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
          searchColumns={warehouseSearchColumns}
          value={state.khoHang?.ma_kho || ''}
          relatedFieldValue={state.khoHang?.ten_kho}
          onRowSelection={actions.setKhoHang}
          columnDisplay='ma_kho'
          displayRelatedField='ten_kho'
          dialogTitle='Danh mục kho hàng'
          className='w-100'
        />
      </div>

      <div className='flex items-center'>
        <Label className='w-32 shrink-0'>Ph/th thanh toán</Label>
        <SearchField<PhuongThucThanhToan>
          type='text'
          name='ma_pttt'
          searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}/`}
          searchColumns={phuongThucThanhToanSearchColumns}
          value={state.phuongThucThanhToan?.ma_pttt || ''}
          relatedFieldValue={state.phuongThucThanhToan?.ten_pttt}
          onRowSelection={actions.setPhuongThucThanhToan}
          columnDisplay='ma_pttt'
          displayRelatedField='ten_pttt'
          dialogTitle='Danh mục phương thức thanh toán'
          className='w-100'
        />
      </div>
    </div>
  );
};
